<script lang="ts">
  import { PartnerModel } from '@24hbs/utils';
  // Utils
  import { handleUrlClientSide } from '$lib/utils/assets-utils';
  import { lazyLoader} from '$lib/utils/lazyloader'
  
  export let lazyLoad: boolean = false;
  export let partner: PartnerModel = new PartnerModel();
  export let borderColor = '#EEC8A4';
</script>

<div class="course-partner-card" style="border-color: {borderColor}">
  <div class="course-partner-wrapper">
    <div class="course-partner-image-wrapper">
      <a href={`/partners/${partner.slug}`}>
        {#if lazyLoad}
          <img
            class="course-partner-image"
            use:lazyLoader={handleUrlClientSide(partner.imageUrl)}
            alt={partner.name}
          />
        {:else}
          <img
            class="course-partner-image"
            src={handleUrlClientSide(partner.imageUrl)}
            alt={partner.name}
          />
        {/if}
      </a>
    </div>
    <!-- <a href="{partner.partnerUrl}" target="_blank">
      <h4 class="course-partner-title">{partner.name}</h4>
    </a> -->
    <!-- p class="course-partner-abstract"></p>
    <p class="course-partner-description"></p -->
  </div>
</div>

<style type="text/scss" lang="scss" scoped>
  .course-partner-card {
    @apply rounded rounded-t-none bg-white shadow-md;
    @apply border-t-2 border-tint;
  }

  .course-partner-wrapper {
    @apply p-4 md:p-6;
  }

  .course-partner-image-wrapper {
    @apply mb-4;
  }

  .course-partner-image {
    @apply w-auto h-auto max-h-12;
    @apply object-contain object-left;
  }

  .course-partner-title {
    @apply font-serif font-medium;
    @apply text-lg;
    @apply mb-3;
  }

  .course-partner-abstract {
    @apply font-sans font-semibold;
    @apply text-sm md:text-base;
    @apply mb-4;
  }
</style>
